"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChatMessageInput = ChatMessageInput;
var _react = _interopRequireDefault(require("react"));
var _streamChatReact = require("stream-chat-react");
var _SendMessageButton = require("../SendMessageButton");
require("./ChatMessageInput.less");
var _ = require("../..");
var _excluded = ["grow", "maxRows"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
function ChatMessageInput(props) {
  var _props$grow = props.grow,
    grow = _props$grow === void 0 ? true : _props$grow,
    _props$maxRows = props.maxRows,
    maxRows = _props$maxRows === void 0 ? 3 : _props$maxRows,
    etcProps = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/_react.default.createElement(_streamChatReact.MessageInput, _extends({
    Input: _.GroupChatMessageInput,
    SendButton: _SendMessageButton.SendMessageButton,
    grow: grow,
    maxRows: maxRows
  }, etcProps));
}